// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

export type SecondaryIdentityDocumentTypeProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const SecondaryIdentityDocumentType = (
  props: SecondaryIdentityDocumentTypeProps,
): JSX.Element => {
  useMountLogging('SecondaryIdentityDocumentType');
  const secondaryIdentityDocumentType = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentType,
  );

  const secondaryIdentityDocumentTypeOptions =
    features.config.secondaryKycIdTypes.map((type: string) => {
      return {
        text: getContent(`fieldValues.${type}`),
        value: type,
      };
    });
  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      data-testid="secondaryIdentityDocumentType"
      focusHandler={props.focusHandler}
      id="secondaryIdentityDocumentType"
      label={getContent('fieldLabels.secondaryIdentityDocumentType')}
      required={true}
      selectOptions={secondaryIdentityDocumentTypeOptions}
      theme={theme}
      {...secondaryIdentityDocumentType}
    />
  );
};

SecondaryIdentityDocumentType.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { SecondaryIdentityDocumentType };
